import { api } from '../client'
import type { WishApplications, WishTicketPostRequest } from './types'

export async function fetchWishApplications() {
  const { data } = await api.get<WishApplications>(`/wish/applications`)
  return data
}

export async function postWishTicket(
  requestBody: WishTicketPostRequest,
  files?: File[],
) {
  const body = new FormData()
  body.append('data', JSON.stringify(requestBody))

  if (files?.length) {
    for (const file of files) {
      body.append('files', file)
    }
  }

  const { data } = await api.post<Record<string, string>>(`/wish/ticket`, body)
  return data
}
